module.exports = __webpack_public_path__ + "static/national-2-web-regular-b553672c7fd7548837eda2afa3be2d65.woff";